<template>
    <a href @click.prevent="toggle" class="child">
        <div class="child-nav">
            <div class="child-info">
                <div class="logged-in-as">{{ activeChild.first_name }}</div>
                <div class="job-title"><span class="tag-bubble" :class="childLevelClass(activeChild)">Level {{ activeChild.level || 'N/A' }}</span></div>
            </div>
            <div class="avatar">
                <div class="profile-photo" :style="`background:url('${ thumbnail(activeChild) }') center center no-repeat; background-size:cover;`"></div>
            </div>
        </div>
    </a>
</template>

<script>

import { mapState } from 'vuex';
import _ from 'underscore';
import ChildMixin from '@/mixins/ChildMixin';

export default {

    mixins: [ ChildMixin ],

    computed: {
        activeChild() {
            return _.findWhere(this.children, { id: this.activeChildId }) || {};
        },

        ...mapState({
            children: state => state.children,
            activeChildId: state => state.activeChildId,
            isOpen: state => state.childSelectorOpen,
        }),
    },

    mounted() {
        document.addEventListener('keyup', (e) => {
            if (e.which === 27) {
                this.$store.dispatch('closeChildSelector');
            }
        });
    },

    methods: {

        open() {
            this.$store.dispatch('openChildSelector');
        },

        close() {
            this.$store.dispatch('closeChildSelector');
        },

        toggle() {
            if (this.isOpen) {
                this.close();
            } else {
                this.open();
            }
        }
    },

}

</script>



// WEBPACK FOOTER //
// resources/js/components/layouts/NowViewingChild.vue